import styled from '@emotion/styled';

// The height until the email loads; after that the frame grows to fit it, so it never scrolls.
export const Frame = styled.iframe<{ $height?: number }>`
    display: block;
    width: 100%;
    height: ${({ $height }) => ($height ? `${$height}px` : '75vh')};
    overflow: hidden;
    border: 1px solid #d0d5dd;
    border-radius: 4px;
    background: #ffffff;
`;
